/**
 * Matches server clientConfig["SHIFTS_ENABLED"] as exposed on GET /api/settings/client (shiftsEnabled).
 */
export function isShiftsFeatureEnabled(settingsPayload) {
	if (!settingsPayload) {
		return false;
	}
	const v = settingsPayload.shiftsEnabled;
	return v === true || v === "true";
}
